import axios from 'axios';
import { API_BASE_URL } from '../api/client';

const authHeaders = () => ({ Authorization: localStorage.getItem('accessToken') });

const refreshAndRetry = async (requestFn) => {
    const role = localStorage.getItem('role');
    const refreshUrl = role === 'MANAGER'
        ? `${API_BASE_URL}/api/v1/manager/token/refresh`
        : role === 'SUPERVISOR'
            ? `${API_BASE_URL}/api/v1/supervisor/token/refresh`
            : null;
    if (!refreshUrl) return [];
    const response = await axios.get(refreshUrl, {
        headers: { Authorization: localStorage.getItem('refreshToken') },
    });
    if (!response.headers.accesstoken) {
        window.location = '/';
        return [];
    }
    localStorage.setItem('accessToken', response.headers.accesstoken);
    return requestFn();
};

/** Constant residents eligible as family-guest hosts (person id = parentId). */
export const filterConstantResidentHosts = (rows) =>
    (Array.isArray(rows) ? rows : []).filter(
        (p) => p?.personType === 'constant' && p?.parentId
    );

export const searchResidentHosts = async (querySuffix = '') => {
    const url = `${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Person${querySuffix}`;
    try {
        let data;
        try {
            data = await axios.get(url, { headers: authHeaders() }).then((r) => r.data);
        } catch (e) {
            data = await refreshAndRetry(() => axios.get(url, { headers: authHeaders() }).then((r) => r.data));
        }
        return filterConstantResidentHosts(data);
    } catch (e) {
        return [];
    }
};
